import {gql} from '@apollo/client';

const UPDATE_PARTNER_VEHICLE_TYPE_COST = gql`
  mutation updateBusPartnerBusTypeCostEntry(
    $id: ID!
    $busTypeId: ID!
    $leasingCost: Float
    $insuranceCost: Float
    $interestCost: Float
    $motorVehicleTax: Float
    $maintenanceCostPerMonth: Float
    $maintenanceCostPerDistanceUnit: CostPerDistance
    $vehicleRegistrationCost: Float
    $customIdentifier: String
    $vehicleProductionYear: Int
  ) {
    updateBusPartnerBusTypeCostEntry(
      input: {
        id: $id
        busTypeId: $busTypeId
        leasingCost: $leasingCost
        insuranceCost: $insuranceCost
        interestCost: $interestCost
        motorVehicleTax: $motorVehicleTax
        maintenanceCostPerMonth: $maintenanceCostPerMonth
        maintenanceCostPerDistanceUnit: $maintenanceCostPerDistanceUnit
        vehicleRegistrationCost: $vehicleRegistrationCost
        customIdentifier: $customIdentifier
        vehicleProductionYear: $vehicleProductionYear
      }
    ) {
      id
      busTypeId
      year
      leasingCost
      insuranceCost
      interestCost
      motorVehicleTax
      maintenanceCostPerMonth
      maintenanceCostPerDistanceUnit
      vehicleRegistrationCost
      customIdentifier
      vehicleProductionYear
    }
  }
`;

export default UPDATE_PARTNER_VEHICLE_TYPE_COST;
